export const AUTHORS_REQUEST = 'AUTHORS_REQUEST'
export const AUTHOR_SAVE = 'AUTHOR_SAVE'
export const AUTHOR_UPDATE = 'AUTHOR_UPDATE'
export const AUTHOR_REQUEST_BY_ID = 'AUTHOR_REQUEST_BY_ID'
export const AUTHOR_GET_NEW_ID = 'AUTHOR_GET_NEW_ID'
export const AUTHORS_SUCCESS = 'AUTHORS_SUCCESS'
export const AUTHORS_REPLACE = 'AUTHORS_REPLACE'
export const SYNC_AUTHORS_BOOKS_INFO = 'SYNC_AUTHORS_BOOKS_INFO'